import React from 'react';
import {
  CallToActionButtonContainer,
  CallToActionContainer,
  CallToActionTextContainer,
  ConfettiElement1,
  ConfettiElement2
} from 'organisms/courses/courses.callToAction.styles';
import Heading from 'elements/typography/heading';
import ButtonSecondary from 'elements/buttons/Button.secondary';
import { navigate } from 'gatsby';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import { ButtonContentfulModel } from 'src/api/models/Button';

interface CoursesCallToActionProps {
  titleHeadings: HeadingContentfulModel[];
  actionButton: ButtonContentfulModel
}

const CoursesCallToAction = ({ titleHeadings, actionButton }: CoursesCallToActionProps): JSX.Element => (
  <CallToActionContainer>
    <CallToActionTextContainer>
      <ConfettiElement1 />
      <ConfettiElement2 />
      {
        titleHeadings.map((headingElement, index) => (
          <Heading
            align="center"
            size="2.5em"
            sizeLg="2em"
            sizeSubLg="1.5em"
            text={headingElement.text}
            key={index}
          />
        ))
      }
    </CallToActionTextContainer>
    <CallToActionButtonContainer>
      <ButtonSecondary
        text={actionButton.text}
        onClick={() => navigate(actionButton.url)} />
    </CallToActionButtonContainer>
  </CallToActionContainer>
);

export default CoursesCallToAction;
